<template>
  <div class="main-wrapper">
    <!--
    <img class="main-logo-panel" src="@/assets/images/pat-banner.png" />
    -->
    <swiper :options="swiperOption">
      <swiper-slide class="main-logo-panel" v-for="(item,index) in bannerArr" :key="index">
        <img :src="item" @click="toDetail(index)" />
      </swiper-slide>
      <!-- 分页器 npm install --save vue-awesome-swiper -->
    <!-- <div class="swiper-pagination" slot="pagination"></div>-->
      <!-- 左右箭头 -->
    <!--  <div class="swiper-button-prev" slot="button-prev"></div>-->
    <!--  <div class="swiper-button-next" slot="button-next"></div>-->
    </swiper>

    <div class="list-loading" v-if="!dataDone">
      <van-loading type="spinner" size="14px">正在加载中...</van-loading>
    </div>
    <div class="doc-card-list" v-if="docList.length>0">
      <div v-for="(item, index) in docList" :key="index">
        <div class="card-item">
          <div class="card-content">
            <div class="user-avatar"><img :src="item.avatar" /></div>

            <div class="user-info">
              <div class="name">{{item.username}}<span>{{item.title | jobTitleFilter}}</span></div>
              <div class="department">{{item.work_unit}}</div>
             <div class="department"><span class="user-dep">{{item.p_dep_title}}<span class="user-dep-span">|</span>{{item.dep_title}}</span></div>

            </div>
            <span class="status-tip ing" v-if="item.enroll.status == 3">诊疗中</span>
             <span class="status-tip booked" v-if="item.enroll.status == 1">已预约</span>
             <span class="status-tip waitting" v-if="item.enroll.status == 2">待诊疗</span>
          </div>
          <!--
          <div class="card-border"></div>
          -->
          <div class="card-content">
            <div class="user-description " v-if="item.adept!=''">
              <div class="user-tip">专业擅长</div>
              {{item.adept}}
            </div>
            <div class="card-bottom" v-if="item.article_count>0" @click="toArticle(item.user_id)">
              <div class="card-bot-article"> 专家文章<em>({{item.article_count}}篇)</em></div>
              <div class="more">阅读>></div>
            </div>
            <!--
          <div class="user-desc-more-control"><div class="txt"><icon icon-class="arrow"></icon></div></div>
          -->
          </div>
          <div class="card-content-btns">
            <div class="card-bot-btn share-doc" @click="toDocShare(item.user_id)">分享医生</div>
             <div class="card-bot-btn to-appoint"  @click="toDoctorDetail(item.user_id)">预约挂号</div>

              <div class="card-bot-btn to-chat" @click="orderLiveChat(item.user_id)">实时问诊</div>

            <!--
            <button class="reservation-button" @click="toDoctorDetail(item.user_id)">
              <icon icon-class="reservation"></icon>预约诊疗
            </button>
            <button class="live-chat-button" @click="orderLiveChat(item.user_id)">
              <icon icon-class="live-chat"></icon>实时问诊
            </button>
            -->
          </div>
        </div>
        <!--
        <div class="status booking" v-if="item.enroll.type == 1">
          <div class="status-text">预约复诊时间：{{item.enroll.start_time | dateFilter('month')}} - {{item.enroll.end_time | timeFilter}}</div>
        </div>
        <div class="status live" v-if="item.enroll.type == 2">
          <div class="status-text">实时问诊：{{item.enroll.start_time | dateFilter('month')}} - {{item.enroll.end_time | dateFilter('month')}}</div>
        </div>
        -->
      </div>
      <div style="height: 105px;"></div>
    </div>
    <div class="new-doc-panel" >
       <div class="btn-boder"></div>
      <div class="add-doctor-button" @click="toBind()">添加医生</div>
      <div class="btn-boder">|</div>
      <div class="to-chatroom-button" @click="toChatRoom()">线上诊室</div>
       <div class="btn-boder"></div>
    </div>
  </div>
</template>

<style lang="less" scoped>
  .main-wrapper{
    width: 100%;
    height: 100%;
    background-color: #fff;
    overflow-y: auto;
    .new-doc-panel{
      position: fixed;
      bottom:0px;
      left: 0px;
      z-index: 800;
      height: 45px;
      background-color: #fff;
      border-top: solid 1px #F4F4F4;
      width: 100%;
      text-align: center;
      box-shadow: 30px 0px 0px 0px rgba(148, 148, 148, 0);
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      .add-doctor-button{
        width: 100px;
        padding:0px 0px 0px 3px;
        margin:2px auto;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        text-align: center;
        padding-left: 15px;
        color: #3668a6;
        font-weight: bold;
        background: url('data:image/png;base64,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') left center no-repeat;
        background-size: 22px 20px;

      }
      .btn-boder{
        width: 20px;
        height: 40px;
        color:#3668A6;
        font-size: 20px;
        text-align: center;
        line-height: 40px;
      }
      .to-chatroom-button{
        width: 100px;
        padding:0px 0px 0px 3px;
        margin:2px auto;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        text-align: center;
        padding-left: 15px;
        color: #3668a6;
        font-weight: bold;
        background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAeCAYAAABNChwpAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjUzODJGNURDNkQ5RjExRUFCODg0OEI2OEUwNDMxNzYzIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjUzODJGNURENkQ5RjExRUFCODg0OEI2OEUwNDMxNzYzIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NTM4MkY1REE2RDlGMTFFQUI4ODQ4QjY4RTA0MzE3NjMiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NTM4MkY1REI2RDlGMTFFQUI4ODQ4QjY4RTA0MzE3NjMiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6djsK6AAABTklEQVR42mL8//8/w0ACJoYBBgPuABbzzOXIfEYgbgbiTCAWItIMUBxeA+I8IN5HaQikAXE1CZbDHK0NxBuBWJRSB7jiUbsNiBXwyPMAsSWlDmDBoW4uEPcC8XMgTgTi89RKU8Rq+AbEX6Hx/QGIf1MtERKpLheI5YA4AYjXD1Q29Afi96MFEdULIhqY6QQtlGAAlGjXAvFmUh0AymrO0JSPC6gB8Uk0MTloekEG8dASto4UB+gA8RICWU6WhJCpAuI5QPyIWAewArEXFaOGGYj1SXHAU2iQ/cOjBlQ015PoCKJzASMRuYSZlrlACohnD2Q2BCW+HQSiAORIU1o54Aq05vuLR40mEB+jlQMMgfjNaKOUHokwBYgjoVlKh0LzWghEK0i+AMr+A8QLQYqnAjEblTykTaK8KSgKlhJI6bQCIDuXMo52zQbaAQABBgDN9DpKGVMPlAAAAABJRU5ErkJggg==') left center no-repeat;
        background-size: 22px 20px;

      }
    }
    .list-loading{
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 23px;
    }
    .main-logo-panel{
      width: 100%;
      margin:0px auto 0px auto;
      position: relative;
      z-index: 1;
      height: 211px;
      img{
        width: 100%;
        max-width: 600px;
      }
    }
    .swiper-button-prev{
      color:#55aaff;
     }
     .swiper-button-next{
        color:#55aaff;
     }
    .doc-card-list{
      width: 96%;
      margin:4px auto;
      display: block;
      min-height: 400px;
      padding: 0 5px 16px;
      border-radius: 8px;
      position: relative;
      z-index: 10;
      margin-top: -50px;
      .status{
        position: relative;
        border-radius: 6px;
        background: rgba(54, 104, 166, 0.06);
        color: #666;
        padding: 6px 17px 0;
        margin-top: -6px;
        font-weight: normal;
        z-index: 10;
        &.live{
          background: rgba(54, 104, 166, 0.06);

        }
        .status-text{
          position: relative;
          font-size: 14px;
          line-height: 32px;
          padding-left: 9px;
          &::after{
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 2px;
            height: 12px;
            background: @xile;
          }
        }
      }
      .card-item {
        margin-top: 12px;
        width: 100%;
        border-radius: 6px;
        padding:10px 0px 20px 0px;
        position: relative;
        background: #FFF;
        padding: 8px 5px;
        border-radius: 6px;
        box-shadow: 0px 4px 20px 0px rgba(0,0,0,0.1);
        z-index: 11;
        .card-border{
        border-top: solid 1px #f3f1f1;
        height:3px ;
        width: 98%;
        margin:2px auto;
        }
        .card-content{
          width: 98%;
          padding:5px 0px;
          margin: 0px auto;
          position: relative;
          .status-tip{
            position: absolute;
            top: 10px;
            right: 8px;
            font-size: 13px;
            line-height: 20px;
            white-space: nowrap;
            &::after{
              content: '';
              position: absolute;
              left: -9px;
              top: 50%;
              transform: translateY(-50%);
              width: 5px;
              height: 5px;
              border-radius: 50%;
            }
            &.booked{
              color: #E2AD2E;
              &::after{
                background: #E2AD2E;
              }
            }
            &.ing{
              color: #00848A;
              &::after{
                background: #00848A;
              }
            }
            &.waitting{
              color: @xile;
              &::after{
                background: @xile;
              }
            }
          }
          .user-avatar{
            width: 55px;
            height: 55px;
            border-radius: 50%;
            display: flex;
            overflow: hidden;
            justify-content: center;
            align-items: center;
            position: absolute;
            left: 5px;
            top:4px;
            img{
              width: 100%;
            }
          }
          .user-info{
            height: 60px;
            margin-top:0px;
            margin-left:75px;
            margin-right: 15px;
            .name{
              font-size: 16px;
              line-height: 18px;
              color: @black;
              font-weight: bold;
              span{
                margin-left: 8px;
                font-size: 14px;
                line-height: 14px;
                color: #919191;
                font-weight: bold;
              }
            }
            .department{
              margin-top: 3px;
              font-size: 14px;
              line-height: 18px;
              color: #757575;
            }
            .user-dep{
              display:inline-block;
              line-height: 17px;
              font-size: 13px;
              padding:1px 0px;
              .user-dep-span{
                display:inline-block;
                text-align: center;
                padding:1px 5px;
                line-height:3px;
              }
            }
          }
          .user-description{
            width: 100%;
            margin:0px auto;
            border-radius: 5px;
            background-color: #f6f6f6;
            color:#4f4f4f;
            padding:8px 12px;
            line-height: 23px;
            font-size: 13px;
            .user-tip{
              height: 25px;
              font-size: 14px;
              color:#4d4d4d;
              font-weight: bold;
              width: 100%;
              margin:0px auto;

            }
          }
          .user-desc-more-control{
            width: 50px;
            left: 0px;
            line-height: 15px;
            margin: -17px auto 0px auto;
            .txt{
              margin:0px auto;
              color:#B3B3B3;
              font-size: 12px;
              text-align: center;
              border:solid 1px #ddd;
              transform:rotate(90deg); -ms-transform:rotate(90deg);
            }
          }
          .user-desc-more{
          }
        }
        .card-content-btns{
          width: 96%;
          padding:5px 0px;
          margin: 0px auto 0px auto;
          position: relative;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          border-top: solid 1px #EEEEEE;
          .card-bot-btn{
            width: 33%;
            height: 30px;
            text-align: center;
            color: #3668a6;
            font-size: 14px;
            line-height: 30px;
            padding-left: 0px;
            margin-left: 9px;
            margin-top: 4px;
            position: relative;
          }
          .card-bot-btn.share-doc{
            background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkQxRDQyMEMyNkNDQTExRUE5NDY5OEFFQ0NCOTlFRTBGIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkQxRDQyMEMzNkNDQTExRUE5NDY5OEFFQ0NCOTlFRTBGIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RDFENDIwQzA2Q0NBMTFFQTk0Njk4QUVDQ0I5OUVFMEYiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RDFENDIwQzE2Q0NBMTFFQTk0Njk4QUVDQ0I5OUVFMEYiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5GadBTAAAB9klEQVR42tSXuUsDQRTGE7XxKgQRbUTxKsVCxMJKULTQQguvxiNK/gMLEa9CiI0W3ogQNSIIHiDaioUiwUILFRNsBPEo1Xhl/Qa+wDrJErKbTfTBj53s7ObLvHlv3otVURRLPCzBEidLCgwq7C71fSsoAjkcq+0eXOoVPJlp/S2ssnYwBvI03vWDXHAn3Rc/cgOka7y3ChxBK6YNgFGOPeAKfErPPBLZMkElSNQQVrSEy8AI+AJdwBmhF89BNkjj5xowJ21fyODq4aRDh2jAnsAtyAATvLcTLqpLed0yGLD5YI97vQyGwgkHXPRgQFTs8z5dfgB6ubem5nEK3VoM3KCJgenn/HfIPDZoIpJdjGovqAcvnBM5vwiOzBCeBg0Mrlppuz6AzQxXD3Iv37jSm1ic1SLfh7mPzeA0FkWiDsxzbGMKmV6dysEmg0rk6VIsymIhV5cMFuhq0+txFg8IcVDsAnsE7/aBDr3p1A8KwDFokQ+FMDYLnsGKHmEnvSTq9auRxiNS4TPyf3uuPyH8LpXHaFqq6twOEvbwWmWCcOA7vaGE13kVB0JJFEVFUzDJsStUVIsivg0aGblr4FrtHh2pI1rkNvZgbnXzJ6eTOBSm2Ph1R3HVYlGdwKcl7GNtHQfVbNKNRL5oCA7BhTxhjdefth8BBgAnjGQEZCmVMAAAAABJRU5ErkJggg==') left center no-repeat;
            background-size: 18px 18px;
          }
          .card-bot-btn.to-appoint{
            background: url('data:image/png;base64,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') left center no-repeat;
            background-size: 18px 18px;
          }
          .card-bot-btn.to-chat{
            background: url('data:image/png;base64,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') left center no-repeat;
            background-size: 18px 18px;
          }
          button{
            @button-base();
            height: 32px;
            svg{
              font-size: 18px;
              margin-right: 4px;
            }
            &.reservation-button{
              width: 128px;
            }
            &.live-chat-button{
              @button-border();
              flex: 1;
              margin-left: 11px;
            }
          }
        }
        .card-bottom{
          width: 98%;
          background-color: #fff;
          margin:0px auto;
          font-size: 14px;
          position: relative;
          padding:5px 6px 1px 6px;
          color: rgba(0, 132, 138, 0.2);
          align-items: center;
          color: #4f4f4f;
          .card-bot-article{
            font-size: 14px;
            color:#4d4d4d;

            font-weight: bold;
            margin-right: 70px;
            line-height: 35px;
            em{
              font-weight: bold;
            }
          }
          .more{
            position: absolute;
            right: 5px;
            top:6px;
            font-size: 11px;
            font-weight: 0;
            width:60px;
            height: 35px;
            text-align: center;
            line-height: 35px;
          }
        }
      }
    }
  }
</style>

<script type="text/javascript">
  export default {
    data() {
      return {
        swiperOption: {
          //显示分页
          pagination: {
            el: '.swiper-pagination'
          },
          //设置点击箭头
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          //自动轮播
          autoplay: {
            delay: 3000,
            //当用户滑动图片后继续自动轮播
            disableOnInteraction: false,
          },
          //开启循环模式
          loop: true
        },
        dataDone: false,
        docList: [],
        bannerArr: [
          require('@/assets/images/banner.png'),
          require('@/assets/images/doc-banner.jpg'),
          require('@/assets/images/yan-doc.jpg')
        ],
      }
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      }
    },
    created() {

      let _this = this;
      _this.$root.post('/getMainDocList', {
        user_id: _this.userInfo.user_id,
      }).then(res => {
        console.log(res.data)
        this.docList = res.data;
        _this.dataDone = true;
      })
    },
    methods: {
      toDetail(index) {
        switch(index){
          case 1:
          this.$router.push({
            path: '/banner1'
          });
          break;
          case 2:
          this.$router.push({
            path: '/banner2'
          });
          break;
        }
      },
      toBind() {
        this.$router.push('/patient/code-binding');
      },
      toChatRoom(){
          this.$router.push('/patient/chat-room');
      },
      toDocShare(doc_id){
        this.$router.push({
          path: '/patient/doc-share',
          query: {
            doc_id: doc_id
          }
        });
      },
      toArticle(doc_id) {
        this.$router.push({
          path: '/article',
          query: {
            doc_id: doc_id
          }

        });
      },
      // 点击预约问诊去医生详情页
      toDoctorDetail(doc_id) {
        this.$router.push({
          name: 'PatientDoctorDetail',
          params: {
            id: doc_id
          }
        });
      },
      // 点击实时问诊跳转实时问诊付款页
      orderLiveChat(doc_id) {
        this.$router.push({
          name: 'PatientChatRoom',
          params: {
            id: doc_id
          }
        });
        /*
        this.$root.post('/isAllowEnroll', {
          pat_id: this.userInfo.user_id,
          doc_id: doc_id,
        }).then(data => {
          if (data.status == 1) {
            this.$router.push({
              path: '/patient/order/payment',
              query: {
                doc_id: doc_id,
                type: 2
              }
            });
          } else {
            this.$notify(data.msg);
          }
        })
        */
      }
    },
    filters: {
      chatTimeFilter(value) {
        return moment(value).format('YYYY年MM月DD日 HH:mm');
      },
      cardTimeFilter(stamp) {

        return moment.unix(stamp).format('YYYY.MM.DD');
      },
      bookDateFilter(stamp) {
        return moment.unix(stamp).format('MM.DD HH:mm');
      },
      bookTimeFilter(stamp) {
        return moment.unix(stamp).format('HH:mm');
      }

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Patient/Index/main.vue